import React, { Component } from "react";
import styled from "styled-components";

import { Menu, MenuItem } from "@material-ui/core";
import { isFullsceenAllowed, isFullscreen, toggleFullscreen } from "../helpers/fullscreen";

import {
    ViewModule as ViewModuleIcon,
    Fullscreen as FullscreenIcon,
    FullscreenExit as FullscreenExitIcon,
    ChromeReaderMode as ChromeReaderModeIcon,
    ModeCommentOutlined as ModeCommentIcon,
    PhoneAndroid,
    PictureAsPdf as PictureAsPdfIcon,
    OpenInNew as OpenInNewIcon,
    Edit as EditIcon,
    List as ListIcon,
    Link as LinkIcon,
    ExitToAppOutlined as ExitToAppOutlinedIcon,
    Share as ShareIcon,
} from "@material-ui/icons";
import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";
import { NestedMenuItem } from "js/react/components/NestedMenuItem";
import { PlayerShortcutView } from "./PlayerShortcutView";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { ShareDialog } from "../../PresentationSettings/dialogs/ShareDialog";

const StyledMenu = styled(Menu)`
  
  & > .MuiPaper-root {
    & > .MuiList-padding {
        padding-top: 0;
        padding-bottom: 0;
    }
  }

  .MuiMenuItem-root {
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    fill: #333333;

    .MuiIcon-root,
    .MuiSvgIcon-root {
      font-size: 24px;
      margin-right: 15px;
      color: #333333;
      fill: #333333;
    }

  }
`;

class MobilePresentationActionsMenu extends Component {
    closeAfterAction = action => {
        const {
            onClose,
            registerUserInteraction,
        } = this.props;

        if (action) {
            action();
            onClose();
            registerUserInteraction?.();
        }
    }

    render() {
        const { open,
            onClose,
            anchorEl,
            anchorPosition,
            showThumbnailsPane,
            onSharePresentation,
            onEditOnDesktop,
            canEditPresentation } = this.props;

        return (
            <StyledMenu
                open={open}
                anchorReference={anchorPosition ? "anchorPosition" : "anchorEl"}
                anchorPosition={anchorPosition}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                disableEnforceFocus
                style={{ zIndex: 999999 }}
                onClose={onClose}
                onClick={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <MenuItem
                    key="slide-grid"
                    onClick={() => this.closeAfterAction(showThumbnailsPane)}
                >
                    <ViewModuleIcon />
                    Grid View
                </MenuItem>

                {canEditPresentation && <MenuItem
                    key="edit-presentation"
                    onClick={() => this.closeAfterAction(onEditOnDesktop)}
                >
                    <EditIcon />
                    Edit
                </MenuItem>}

                {canEditPresentation && <MenuItem
                    key="share-presentation"
                    onClick={() => this.closeAfterAction(onSharePresentation) }
                >
                    <ShareIcon />
                    Share
                </MenuItem>}

            </StyledMenu>
        );
    }
}

export default MobilePresentationActionsMenu;
